/* eslint-disable import/order */

import React, { FC } from 'react';
import NonUaePassSignConsent from './NonUaePassSignConsent';
// import UaePassSignContract from './UaePassSignContract';
import { isLoggedInWithUaePass } from '~/utils/getDecodedJwt';

const SignConsent: FC = () => {
  // TODO : UAEPASS to be implemented later for R2
  return <NonUaePassSignConsent />;
};

export default SignConsent;
